/* 🤖 this file was generated by script */
export const wiconCurrencyDollarCircle = {
  name: 'currency_dollar_circle',
  data: `<svg viewBox="0 0 24 24"><path fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M8.5 14.67A2.33 2.33 0 0010.83 17H13a2.5 2.5 0 000-5h-2a2.5 2.5 0 010-5h2.17a2.33 2.33 0 012.33 2.33M12 5.5V7m0 10v1.5M22 12a10 10 0 11-20 0 10 10 0 0120 0z"/></svg>`,
};
